import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_container_export/show_process/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  },
  fetchContainer(container_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_container_export/show_container/fetch_container/${container_id}`
    );
  },
  fetchContainerAttachments(container_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_container_export/show_container/fetch_container_attachments/${container_id}`
    );
  },
  downloadContainerAttachment(container_id, container_attachment_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_container_export/show_container/download_container_attachment/${container_id}/${container_attachment_id}`,
      { responseType: "blob" }
    );
  },
  fetchPackingListFormats(container_id) {
    return RequesterV1.get(
      "agro_exporter/production/query_container_export/show_container/fetch_packing_list_formats/" +
      container_id
    );
  },
  downloadPackingListXlsx(container_id, packing_list_format_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_container_export/show_container/download_packing_list_xlsx/${container_id}/${packing_list_format_id}`,
      { responseType: "blob" }
    );
  }
};
